const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: {
      title: "Din deltagelse i online træning",
      content:
        "Kære kunde<br/>Tak fordi du deltog i online træning af <br/>og besvarede et par spørgsmål bagefter.<br/> Venlig hilsenDit BRIDGESTONE PLUS team",
    },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: { title: "", content: "" },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Tak for din tilmelding til BRIDGESTONE PLUS",
      content:
        "Kære<br/><br/>Tak for din tilmelding. Vi er glade for at kunne informere dig om, at din registrering på BRIDGESTONE PLUS er blevet gennemgået og godkendt.<br/>Vi håber, at BRIDGESTONE PLUS giver dig succes og værdifulde muligheder, og vi ser frem til et fortsat samarbejde.<br/>Venlig hilsen<br/>BRIDGESTONE PLUS-teamet",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: {
      title: "Salgskampagner",
      content:
        "Kære,<br/>Tak for din deltagelse i salgskampagner.<br/>Med venlig hilsen<br/>Bridgestone Plus Team",
    },
  },
};

export default {
  messages,
};
